<template>
    <div class="RiskMannNavbarSeleccionarEmpresa">
        <div class="modal fade" id="SeleccionarEmpresa" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="SeleccionarEmpresaLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl modal-fullscreen-md-down">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="SeleccionarEmpresaLabel">Seleccionar Espacio de Trabajo</h5>
                    </div>
                    <div class="modal-body">
                        <p>
                            Hemos detectado que el espacio de trabajo <b>{{ empresa }}</b> que tenías seleccionado ha
                            sido <b>eliminado</b>.
                            Selecciona uno de los espacios de trabajo de los cuales estás vinculado para continuar
                            navegando por <b>RiskMann</b>.
                        </p>
                        <ListaEmpresas :esModal="true" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListaEmpresas from '../Footer/Empresas/ListaEmpresas.vue';
export default {
    name: "RiskMannNavbarSeleccionarEmpresa",

    components: {
        ListaEmpresas
    },

    props: {
        empresa: String
    }
}
</script>